[
  {
    "path": "/",
    "title": "My PT — Yakınındaki kişisel antrenörü ve PT stüdyosunu bulun",
    "description": "Haritadan kişisel antrenör ve salon keşfedin, saatlik PT stüdyosu kiralayın. Antrenörler ve stüdyolar için ders, öğrenci ve ödeme takibi; 14 gün ücretsiz.",
    "indexable": true,
    "breadcrumb": null
  },
  {
    "path": "/fiyatlar",
    "title": "Fiyatlar — My PT personal trainer uygulaması",
    "description": "Personal trainer uygulaması My PT: aylık 999 ₺, yıllık 9.999 ₺ (KDV dahil). Tüm özellikler iki planda aynı. 14 gün ücretsiz deneme.",
    "indexable": true,
    "breadcrumb": "Fiyatlar"
  },
  {
    "path": "/sss",
    "title": "Sık sorulan sorular — My PT",
    "description": "Personal trainer uygulaması My PT hakkında sık sorulan sorular: ücretsiz deneme, iptal, ödeme, veri güvenliği ve KVKK.",
    "indexable": true,
    "breadcrumb": "Sık sorulan sorular"
  },
  {
    "path": "/iletisim",
    "title": "İletişim — My PT",
    "description": "AURA FİT Spor ve Sağlıklı Yaşam Merkezi A.Ş. iletişim bilgileri: adres, telefon, e-posta, vergi ve MERSİS. Sorularınız için bize yazın.",
    "indexable": true,
    "breadcrumb": "İletişim"
  },
  {
    "path": "/hesap-silme",
    "title": "Hesap silme — My PT",
    "description": "My PT hesabınızı ve kişisel bilgilerinizi kalıcı olarak silmek için adımlar ve uygulama dışından hesap silme formu.",
    "indexable": true,
    "breadcrumb": "Hesap silme"
  },
  {
    "path": "/404",
    "title": "Sayfa bulunamadı — My PT",
    "description": "Aradığınız sayfa bulunamadı. My PT ana sayfasından, fiyatlardan ya da iletişim sayfasından devam edebilirsiniz.",
    "indexable": false,
    "breadcrumb": null
  }
]
